import { DataSourceType } from './dataSourceType';
import { DataTransform } from './dataTransform';
import { DataConnectorMapping } from './dataConnectorMapping';
import { TransformType } from './transformType';
import { RowExtractorTransform } from './rowExtractorTransform';
import { EventNamerTransform } from './transformers/eventNamerTransform';
import { EventGroupNamerTransform } from './transformers/eventGroupNamerTransform';
import { GroupAttributorTransform } from './transformers/groupAttributorTransform';
import { ColumnCalcTransform } from './transformers/columnCalcTransform';
import { ActivityNamingTransform } from './transformers/activityNamingTransform';
import { ColumnLookupTransform } from './transformers/columnLookupTransform';
import { FarmConverterTransform } from './transformers/farmConverterTransform';
import { JoinerTransform } from './transformers/joinerTransform';
import { RowFillerTransform } from './transformers/rowFillerTransform';
import { DataTypeConverter, DeduplicateRows, DurationBuilder, GeneralParameter } from './ingestTransforms';
import { AnonymizerTransform } from './transformers/anonymizerTransform';
import { ColumnCleanerTransform } from './transformers/columnCleanerTransform';

export class DataTransformerConfig {
    guid?: string;
    id?: number;
    name: string;
    selectedIngestFarmGuid?: string;
    organizationId: number;
    createdDateTime: Date;
    modifiedByUserId: number;
    modifiedDateTime: Date;
    dataSourceType: DataSourceType;
    dataConnectorMappings: DataConnectorMapping[];
    transforms: DataTransform<any>[] = [];

    dataTypeConverter?: DataTypeConverter = null;
    durationBuilder?: DurationBuilder = null;
    deduplicateRows?: DeduplicateRows = null;
    generalParameter?: GeneralParameter = null;

    static fromJSON(data: any): DataTransformerConfig {
        //console.log(`fromJson invoked: ${data}`);
        const config: DataTransformerConfig = Object.assign(new DataTransformerConfig(), data);

        config.modifiedDateTime = new Date(config.modifiedDateTime);
        config.createdDateTime = new Date(config.createdDateTime);

        const dataConnectorMappings: DataConnectorMapping[] = [];
        config.dataConnectorMappings.forEach(connector => {
            const dataConnectorMapping = DataConnectorMapping.fromJSON(connector);
            dataConnectorMappings.push(dataConnectorMapping);
        });
        config.dataConnectorMappings = dataConnectorMappings;

        // Transforms
        const transforms: DataTransform<any>[] = [];
        config.transforms.forEach(t => {
            transforms.push(DataTransformerConfig.deserializeTransform(t));
        });
        config.transforms = transforms;
        config.dataTypeConverter=DataTypeConverter.fromJSON(config.dataTypeConverter);
        config.durationBuilder=DurationBuilder.fromJSON(config.durationBuilder);
        config.deduplicateRows=DeduplicateRows.fromJSON(config.deduplicateRows);
        config.generalParameter=GeneralParameter.fromJSON(config.generalParameter);
        return config;
    }

    public static deserializeTransform(t: DataTransform<any>): DataTransform<any> {
        switch (t.transformType) {
            case TransformType.activityNamer:
                return  ActivityNamingTransform.fromJSON(t);
            case TransformType.rowExtractor:
                return RowExtractorTransform.fromJSON(t);
            case TransformType.eventNamer:
                return EventNamerTransform.fromJSON(t);
            case TransformType.eventGroupNamer:
                return EventGroupNamerTransform.fromJSON(t);
            case TransformType.groupAttributor:
                return GroupAttributorTransform.fromJSON(t);
            case TransformType.columnCalc:
                return ColumnCalcTransform.fromJSON(t);
            case TransformType.columnLookup:
                return ColumnLookupTransform.fromJSON(t);
            case TransformType.farmConverter:
                return FarmConverterTransform.fromJSON(t);
            case TransformType.farmJoiner:
                return JoinerTransform.fromJSON(t);
            case TransformType.rowFiller:
                return RowFillerTransform.fromJSON(t);
            case TransformType.anonymizer:
                return AnonymizerTransform.fromJSON(t);
            case TransformType.columnCleaner:
                return ColumnCleanerTransform.fromJSON(t);
            default:
                throw new Error('Unsupported transform type: ' + t.transformType.toString());
        }
    }
    
}
export class IngestTransformerConfig {
    // Existing fields
    runDataTypeConverter?: boolean;
    ingestOnFail?: boolean;
    durationUnits?: string;
  
    // New fields for duplicate rows
    deduplicateRows?: boolean;
    whichRowKeep?: string;
    threads?:number;

    runIngestDuration?:boolean;
    eventStartField?:string;
   



  
    constructor(ingestTransformerParameters?) {
      this.runDataTypeConverter = ingestTransformerParameters?.runDataTypeConverter ?? true;
      this.ingestOnFail = ingestTransformerParameters?.ingestOnFail ?? true;
      this.durationUnits = ingestTransformerParameters?.durationUnits ?? '';
      
      // Initialize the new fields
      this.deduplicateRows = ingestTransformerParameters?.deduplicateRows ?? false;
      this.whichRowKeep = ingestTransformerParameters?.whichRowKeep ?? 'first'; // defaulting to 'first' or you can choose another default
      this.threads = ingestTransformerParameters?.threads ?? '0'; // defaulting to 'first' or you can choose another default
   
       this.runIngestDuration = ingestTransformerParameters?.runIngestDuration ?? true;
       this.eventStartField = ingestTransformerParameters?.eventStartField ?? 'subtaskTimestamp';
    }
  }